import {RepositoryRunners as RepositoryRunnersView} from '@github-ui/actions-runners'
import type {
  GitHubHostedRunnersResponse,
  RunnersQueryState,
  SelfHostedRunnersData,
} from '@github-ui/actions-runners/types'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useParams, useSearchParams} from '@github-ui/react-router'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {useAnalytics} from '@github-ui/use-analytics'
import {useEffect} from 'react'

import {actionsRunnersRoute, selectedRunnersTab} from './actions-runners-route'

export function RepositoryRunners() {
  const {owner = '', repo = ''} = useParams()
  const [searchParams] = useSearchParams()
  const {sendAnalyticsEvent} = useAnalytics()
  const fetchRunnersBasePath = `/${owner}/${repo}/actions/runners`
  const selectedTab = selectedRunnersTab(searchParams)
  const query = useRouteQuery(actionsRunnersRoute, 'mainQuery')
  const {isServer} = useRuntimeEnvironment()
  // The query data is a union keyed by tab; narrow it to the selected tab.
  const data = !isServer && query.data?.tab === selectedTab ? query.data.runners : undefined
  const failed = !isServer && query.isError
  const runnersState: RunnersQueryState<GitHubHostedRunnersResponse | SelfHostedRunnersData> = {
    data,
    isLoading: (data === undefined && !failed) || (failed && query.isFetching),
    error: failed,
    retry: () => void query.refetch(),
  }

  useEffect(() => {
    sendAnalyticsEvent('view_rendered', undefined, {
      name: `repository_runners/${selectedTab.replace('-', '_')}`,
    })
  }, [selectedTab, sendAnalyticsEvent])

  return (
    <RepositoryRunnersView
      selectedTab={selectedTab}
      githubHostedRunnersPath={fetchRunnersBasePath}
      selfHostedRunnersPath={`${fetchRunnersBasePath}?tab=self-hosted`}
      fetchRunnersBasePath={fetchRunnersBasePath}
      softNavigationEnabled
      runnersState={runnersState}
    />
  )
}
